import { useDispatch, useSelector } from "react-redux";
import { closePrint, setPrintType } from "../Store/Slices/printSlice";
import PrintComponent from "./PrintComponent";
import { normalizePrintData } from "./printNormalizer";
import { thermalPrintHTML, fullPrintHTML } from "./printTemplates";

const PrintPopup = () => {
  const dispatch = useDispatch();
  const { isOpen, record, printType } = useSelector((s) => s.print);

  if (!isOpen || !record) return null;


const handlePrint = () => {
  const d = normalizePrintData(record);

  const html = printType === "THERMAL" ? thermalPrintHTML(d) : fullPrintHTML(d);

  const iframe = document.createElement("iframe");
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(`
    <html>
      <head>
        <style>
          body { margin:0; padding:0; }
          @page { margin:0; }
        </style>
      </head>
      <body>${html}</body>
    </html>
  `);
  doc.close();

  iframe.onload = () => {
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
  };
};

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end md:items-center justify-center">
      <div className="bg-white w-full md:w-[50vw] h-[85vh] md:h-[70vh]
                      rounded-t-2xl md:rounded-2xl p-4 flex flex-col">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-lg font-semibold">Print Preview</h3>
          <button onClick={() => dispatch(closePrint())}>✕</button>
        </div>

        {/* TYPE SWITCH */}
        <div className="flex gap-2 mb-3">
          {["FULL", "THERMAL"].map((type) => (
            <button
              key={type}
              onClick={() => dispatch(setPrintType(type))}
              className={`flex-1 py-2 rounded-lg border font-semibold
                ${
                  printType === type
                    ? "bg-indigo-600 text-white"
                    : "border-indigo-600 text-indigo-600"
                }`}
            >
              {type}
            </button>
          ))}
        </div>

        {/* PREVIEW */}
        <div className="flex-1 overflow-auto border rounded p-2 mb-3 bg-slate-50">
          <PrintComponent record={record} printType={printType} />
        </div>

        {/* PRINT */}
        <button
          onClick={handlePrint}
          className="w-full py-2 rounded bg-indigo-600 text-white font-semibold"
        >
          Print
        </button>
      </div>
    </div>
  );
};

export default PrintPopup;

